if (!customElements.get('sonic-about-awards')) {
  customElements.define('sonic-about-awards', class extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('.sonic-about__awards');
      if (!this.list || this.list.children.length < 2) return;
      this.mobile = matchMedia('(max-width: 700px)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.listeners = new AbortController();
      this.paused = false;
      this.visible = false;
      const options = { signal: this.listeners.signal };
      this.list.tabIndex = 0;
      this.list.addEventListener('pointerdown', () => this.pause(), options);
      this.list.addEventListener('keydown', () => this.pause(), options);
      this.list.addEventListener('focusin', () => this.pause(), options);
      this.list.addEventListener('mouseenter', () => this.stop(), options);
      this.list.addEventListener('mouseleave', () => this.schedule(), options);
      this.mobile.addEventListener('change', () => {
        this.list.scrollLeft = 0;
        this.schedule();
      }, options);
      this.reduced.addEventListener('change', () => this.schedule(), options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.schedule();
      });
      this.observer.observe(this);
      this.schedule();
    }

    pause() {
      this.paused = true;
      this.schedule();
    }

    stop() {
      clearTimeout(this.timer);
    }

    schedule() {
      this.stop();
      if (!this.mobile.matches || this.reduced.matches || this.paused || !this.visible || document.hidden) return;
      this.timer = setTimeout(() => {
        const index = Math.round(this.list.scrollLeft / this.list.clientWidth);
        const next = (index + 1) % this.list.children.length;
        this.list.scrollTo({ left: next * this.list.clientWidth, behavior: next === 0 ? 'instant' : 'smooth' });
        this.schedule();
      }, 3000);
    }

    disconnectedCallback() {
      this.stop();
      this.listeners?.abort();
      this.observer?.disconnect();
    }
  });
}
